import { mode } from '@chakra-ui/theme-tools';
export const buttonStyles = {
	components: {
		Button: {
			baseStyle: {
				borderRadius: '16px',
				boxShadow: '45px 76px 113px 7px rgba(112, 144, 176, 0.08)',
				transition: '.25s all ease',
				boxSizing: 'border-box',
				_focus: {
					boxShadow: 'none'
				},
				_active: {
					boxShadow: 'none'
				}
			},
			variants: {
				outline: () => ({
					borderRadius: '16px'
				}),
				brand: (props: any) => ({
					bg: mode('wine.700', 'wine.600')(props),
					color: 'white',
					_focus: {
						bg: mode('wine.700', 'wine.600')(props)
					},
					_active: {
						bg: mode('wine.700', 'wine.600')(props)
					},
					_hover: {
						bg: mode('wine.600', 'wine.500')(props)
					}
				}),
				darkBrand: (props: any) => ({
					bg: mode('wine.800', 'wine.600')(props),
					color: 'white',
					_focus: {
						bg: mode('wine.800', 'wine.600')(props)
					},
					_active: {
						bg: mode('wine.800', 'wine.600')(props)
					},
					_hover: {
						bg: mode('wine.700', 'wine.500')(props)
					}
				}),
				lightBrand: (props: any) => ({
					bg: mode('wine.50', 'whiteAlpha.100')(props),
					color: mode('wine.700', 'white')(props),
					_focus: {
						bg: mode('wine.50', 'whiteAlpha.100')(props)
					},
					_active: {
						bg: mode('wine.100', 'whiteAlpha.100')(props)
					},
					_hover: {
						bg: mode('wine.100', 'whiteAlpha.200')(props)
					}
				}),
				light: (props: any) => ({
					bg: mode('secondaryGray.300', 'whiteAlpha.100')(props),
					color: mode('secondaryGray.900', 'white')(props),
					_focus: {
						bg: mode('secondaryGray.300', 'whiteAlpha.100')(props)
					},
					_active: {
						bg: mode('secondaryGray.300', 'whiteAlpha.100')(props)
					},
					_hover: {
						bg: mode('secondaryGray.400', 'whiteAlpha.200')(props)
					}
				}),
				action: (props: any) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('gold.100', 'wine.600')(props),
					color: mode('wine.700', 'white')(props),
					_focus: {
						bg: mode('gold.100', 'wine.600')(props)
					},
					_active: { bg: mode('gold.200', 'wine.600')(props) },
					_hover: {
						bg: mode('gold.200', 'wine.500')(props)
					}
				}),
				setup: (props: any) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('transparent', 'brand.400')(props),
					border: mode('1px solid', '0px solid')(props),
					borderColor: mode('secondaryGray.400', 'transparent')(props),
					color: mode('secondaryGray.900', 'white')(props),
					_focus: {
						bg: mode('transparent', 'brand.400')(props)
					},
					_active: { bg: mode('transparent', 'brand.400')(props) },
					_hover: {
						bg: mode('secondaryGray.100', 'brand.400')(props)
					}
				}),
				success: (props: any) => ({
					bg: '#0ea396',
					color: 'white',
					_focus: {
						bg: '#0ea396'
					},
					_active: {
						bg: '#0c8a7f'
					},
					_hover: {
						bg: '#0c8a7f'
					}
				}),
				secondary: (props: any) => ({
					bg: '#bb8c52',
					color: 'white',
					_focus: {
						bg: '#bb8c52'
					},
					_active: {
						bg: '#a67a47'
					},
					_hover: {
						bg: '#a67a47'
					}
				})
			}
		}
	}
};
